import { useState } from 'react';
import Navbar from './Navbar';
import { Link, Image, IconButton, MenuIcon } from 'theme-ui';
import { Flex } from 'lib/ui';
import getMenuItems from './getMenuItems';
import logo from 'images/logo_slotted.png';
import { useCurrentUser } from 'lib/hooks/useCurrentUser';

export default function TopNav({ height, width, className }: any) {
  const { currentUser }  = useCurrentUser();

  const [menuOpen, setMenuOpen] = useState<boolean>();
  const menuItems = getMenuItems(currentUser);

  const toggleMenu = () => {
    setMenuOpen(open => !open);
  };

  return (
    <Flex
      id="top-nav"
      alignItems="center"
      className={className}
      backgroundColor="#32312c"
      sx={{
        width: '100vw',
        position: 'fixed',
        right: 0,
        left: 0,
        top: 0,
        overflow: 'visible',
        zIndex: 1030,
      }}
    >
      <Flex
        id="top-nav-inner"
        alignItems={['flex-start', null, null, 'center']}
        direction={[ 'column', null, null, 'row']}
        justifyContent={['center', null, null, 'flex-start']}
        m="0 auto"
        sx={{
          width
        }}
      >
        <Flex
          id="top-nav-inner-left"
          alignItems="center"
          sx={{
            height,
            width: ['100%', null, null, 'auto']
          }}
        >
          <Link
            href="/"
            sx={{
              display: 'flex'
            }}
          >
            <Image
              title="Logo"
              src={logo}
              width={201}
              height={36}
            />
          </Link>
          <Flex
            ml="auto"
          >
            <IconButton
              variant="menu"
              ml="auto"
              color="#a09e99"
              sx={{
                p: 0,
                display: ['auto', null, null, 'none']
              }}
              onClick={toggleMenu}
            >
              <MenuIcon size={40} />
            </IconButton>
          </Flex>
        </Flex>
        <Navbar
          menuItems={menuItems}
          sx={{
            display: [menuOpen ? 'flex' : 'none', null, null, 'flex']
          }}
        />
      </Flex>
    </Flex>
  );
}
